/** Returns whether the value is a function. Acts as a type guard. */
export function isFunction(value: any): value is Function {
  return typeof value === 'function';
}
